import { render, staticRenderFns } from "./EditPromotionsModal.vue?vue&type=template&id=1ac7341b&"
import script from "./EditPromotionsModal.vue?vue&type=script&lang=js&"
export * from "./EditPromotionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports